/* eslint-disable */

import React, { useEffect } from "react";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropToggleWithTitle from "../../../ui-components/raindrop-toggle-with-title/raindrop-toggle-with-title.tsx";

import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import { fetchGraphQL } from "../../../services/api-raindrop";
import { Size } from "../../../logic/enums.ts";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";

const LocalNotificationHelper = () => {
  const onClickFollowNotification = () => {
    fetchGraphQL(`
      mutation {
        debugNotificationFollowCreate {
          id
        }
      }
    `).then((data) => {
      console.log(data);
    });
  };
  return (
    <RaindropCard>
      <h1 className="text-left w-full text-color-dark-text-secondary">
        Local help
      </h1>
      <div className="flex flex-row gap-2">
        <RaindropButton
          title="Create Notification"
          style={ButtonStyle.Primary}
          size={Size.Large}
          onClick={onClickFollowNotification}
        />
      </div>
    </RaindropCard>
  );
};

const RaindropSettingsNotifications = () => {
  const [hasLoaded, setHasLoaded] = React.useState(false);

  const [enableOrganisation, setEnableOrganisation] = React.useState(false);
  const [enablePeople, setEnablePeople] = React.useState(false);
  const [enableMarketing, setEnableMarketing] = React.useState(false);

  const onToggleUpdate = ({ key, value }) => {
    fetchGraphQL(`
      mutation {
        userSettingUpdate(
          key: "${key}",
          value: "${value ? "TRUE" : "FALSE"}"
        ) 
      }
    `);
  };

  useEffect(() => {
    fetchGraphQL(`
      query {

        organisationSetting: userSettingValue (
          key: "USER_SETTING__NOTIFICATION__ORGANISATION__DO_SEND_EMAIL"
        ) 

        peopleSetting: userSettingValue (
          key: "USER_SETTING__NOTIFICATION__PEOPLE__DO_SEND_EMAIL"
        ) 

        marketingSetting: userSettingValue (
          key: "USER_SETTING__NOTIFICATION__MARKETING__DO_SEND_EMAIL"
        ) 

      }
    `).then((response) => {
      setEnableOrganisation(response.data.organisationSetting === "TRUE");
      setEnablePeople(response.data.peopleSetting === "TRUE");
      setEnableMarketing(response.data.marketingSetting === "TRUE");
      setHasLoaded(true);
    });
  }, []);

  if (!hasLoaded) {
    return (
      <div className={"flex flex-col h-full pt-4 gap-4  "}>
        <h1 className="font-bold text-left text-5xl w-full pt-8 pb-4">
          Notification Settings
        </h1>
        <RaindropCard>
          <p className="text-color-dark-text-secondary text-left">Loading...</p>
        </RaindropCard>
      </div>
    );
  }

  return (
    <RaindropPage hasBackNavigation={true}>
      <RaindropTextHeading1>Organisation</RaindropTextHeading1>

      <RaindropToggleWithTitle
        title={"Organisation updates"}
        subtitle={"A supported organisation posts an update"}
        initialIsOn={enableOrganisation}
        onToggle={(newValue) =>
          onToggleUpdate({
            key: "USER_SETTING__NOTIFICATION__ORGANISATION__DO_SEND_EMAIL",
            value: newValue,
          })
        }
      />

      <RaindropTextHeading1>People</RaindropTextHeading1>
      <RaindropToggleWithTitle
        title={"People updates"}
        subtitle={"Shnoodle starts a waterfall, or makes a post, etc"}
        initialIsOn={enablePeople}
        onToggle={(newValue) =>
          onToggleUpdate({
            key: "USER_SETTING__NOTIFICATION__PEOPLE__DO_SEND_EMAIL",
            value: newValue,
          })
        }
      />

      <RaindropTextHeading1>Raindrop</RaindropTextHeading1>
      <RaindropToggleWithTitle
        title={"Marketing updates"}
        subtitle={"We want to build cool things and tell you about it"}
        initialIsOn={enableMarketing}
        onToggle={(newValue) =>
          onToggleUpdate({
            key: "USER_SETTING__NOTIFICATION__MARKETING__DO_SEND_EMAIL",
            value: newValue,
          })
        }
      />
      <RaindropToggleWithTitle
        title={"Legal updates"}
        subtitle={"Things like receipts, we have to send these, sorry!"}
        isDisabled={true}
      />
    </RaindropPage>
  );
};

export default RaindropSettingsNotifications;
